/**
 * Created by vetal on 15.11.16.
 */
define('plugin/kiosk/KioskPlugin',['require','lib/plugin/PluginAbstract','lib/AppRouter','plugin/kiosk/model/KioskModel','Config','lib/Navigation'],function (require) {

    var PluginAbstract = require('lib/plugin/PluginAbstract');
    var AppRouter = require('lib/AppRouter');
    var KioskModel = require('plugin/kiosk/model/KioskModel');
    var Config = require('Config');
    var Navigation = require('lib/Navigation');

    return PluginAbstract.extend({

        _collection : null,
        _moduleView: null,
        _redirectUrl : '/',
        _kioskModel: null,
        _clientModel: null,
        _bookingModel : null,
        _timeoutTimer : null,

        initialize: function () {
            this._kioskModel = new KioskModel();
            this._clientModel = this.getOption('clientModel');
            this._setupRedirectUrl();
            this._kioskModel.on('sync', _.bind(function () {
                this._clearOtherModels();
            }, this));

            this._redirectInactive();
        },

        _setupRedirectUrl: function(){
            var config = Config.getInstance();

            if(config.getOption('kiosk_custom_url')){
                this._redirectUrl = config.getOption('kiosk_custom_url');
                return;
            }

            if(config.getOption('is_widget')){
                if(config.getOption('last_navigate')){
                    this._redirectUrl = config.getOption('last_navigate');
                } else {
                    switch (config.getOption('widget_type')) {
                        case 'contact-button':
                        case 'contact':
                            this._redirectUrl = 'contact-widget';
                            break;

                        case 'reviews':
                            this._redirectUrl = 'reviews';
                            break;

                        case 'iframe':
                        default:
                            this._redirectUrl = 'book';
                            break;
                    }
                }
            }

            //console.log(this._redirectUrl);
        },

        initStepManagerEvents: function () {
            this._bookingModel = this._stepManager.getBookingModel();
        },

        /**
         * On show client bookings page.
         * If we got cart_id we will load cart status from server
         *
         * @param BookingResultView view
         * @param Object data
         */
        onShowClientBookings: function (view, data) {
           // this._redirectHome();
        },

        /**
         * On finish payment
         *
         * @param view
         * @param data
         */
        onFinishPayment: function (view, data) {
            this._redirectHome();
        },
        /**
         * On finish booking
         *
         * @param view
         * @param data
         */
        onFinishBooking: function (data) {
            if(data && data.confirm){  //booking is
                var invoice = data.invoice;

                if(!invoice){
                    this._redirectHome();
                } else if(invoice && !invoice.get('id')){
                    this._redirectHome();
                }
            }
        },


        _redirectHome : function(){
            var config = Config.getInstance();
            var timeoutSec = config.getOption('kiosk_booking_redirect_timeout');
            var clearData = config.getOption('kiosk_clear_data');

            clearTimeout(this._timeoutTimer);
            this._timeoutTimer = setTimeout(_.bind(function () {
                this._setupRedirectUrl();
                console.log('kiosk plugin: redirect after booking');
                if(clearData && parseInt(clearData)){
                    this.clearSession();
                    this.clearCookies();
                    this.clearLocalStorage();
                }
                this._redirectWithReplace(this._redirectUrl);
            }, this), timeoutSec?parseInt(timeoutSec)*1000:1);
        },

        _redirectInactive : function(){
            var config = Config.getInstance();
            var timeoutSec = config.getOption('kiosk_no_activity_redirect_timeout');
            var clearData = config.getOption('kiosk_clear_data');
            var timer = null;

            var resetTimer = _.bind(function() {
                this._setupRedirectUrl();
                //console.log('reset timer');
                clearTimeout(timer);
                timer = setTimeout(_.bind(function () {
                    console.log('kiosk plugin: inactive redirect');
                    if (clearData && parseInt(clearData)) {
                        this.clearSession();
                        this.clearCookies();
                        this.clearLocalStorage();
                    }
                    this._redirectWithReplace(this._redirectUrl);
                }, this), timeoutSec ? parseInt(timeoutSec) * 1000 : 1);
            }, this);

            jQuery('body').bind('mousemove touchmove keydown', function(event) {
                resetTimer();
            });

            resetTimer();
        },

        clearCookies : function(){
            document.cookie.split(";").forEach(function(c) {
                document.cookie = c.replace(/^ +/, "")
                    .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
            });
        },

        clearLocalStorage : function(){
            if(typeof localStorage !== 'undefined') {
                localStorage.clear();
            }
        },

        _clearOtherModels : function(){
            this._clientModel.set('is_logged_in' , false);
            this._clientModel.trigger('perform:signout');

            this._bookingModel = this._stepManager.getBookingModel();

            if(this._bookingModel) {
                //console.log(this._bookingModel);
                this._bookingModel.set({
                    'client_name': '',
                    'client_phone': '',
                    'client_email': '',
                    'client_hash': null,
                    'client_id': null,
                    'fb_name': null,
                    'fb_id': null,
                    'fb_token': null
                });
            }
        },

        clearSession : function(){
            var _this = this;
            this._kioskModel.clear(function (){
                console.log('session cleared');
            });
        },

        initModules: function (view) {

        },

        _redirectWithReplace: function (path, options) {
            path = String(path || '');

            if(path.indexOf('http') === 0){
                window.location.href = path;
                return;
            }

            if (path === '/') {
                path = ''; // the home page of the booking page, not the site root
            }

            if (_.isUndefined(options)) {
                options = {
                    replace: true
                };
            }
            // any form of a page of the booking page: 'book', '#book', '/v2/#book', '/v2/book/'
            Navigation.go(path, options);
        }
    });

});
